document.addEventListener("DOMContentLoaded", () => {
    const addToCartButton = document.querySelector(
      'button[name="add"].btn--add-to-cart'
    );
  
    const stickyCart = document.querySelector(".sticky-cart");
  
    if (addToCartButton && stickyCart) {
      stickyCart.style.display = "none";
  
      // Function to check if the button is in the viewport
      const isElementInViewport = (element) => {
        const rect = element.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <=
            (window.innerWidth || document.documentElement.clientWidth)
        );
      };
  
      window.addEventListener("scroll", () => {
        if (isElementInViewport(addToCartButton)) {
          stickyCart.style.display = "none";
        } else {
          stickyCart.style.display = "flex";
        }
      });
    }
    
  });
  